import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Computer } from 'src/app/models/computer.model';
import { User } from 'src/app/models/user.model';
import { ApiService } from 'src/app/services/api.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { UserService } from 'src/app/services/user.service';
import { UtilsService } from 'src/app/services/utils.service';
import { CreditComputerDialogComponent } from './credit-computer-dialog/credit-computer-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { IndexTemplateComponent } from '@bisual/ngx-index-template';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-computers',
  templateUrl: './computers.component.html',
  styleUrl: './computers.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButton,
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    MatPaginator,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatFormField,
    MatSelect,
    MatOption,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    DatePipe,
  ],
})
export class ComputersComponent extends IndexTemplateComponent {
  private api = inject(ApiService);
  private dialog = inject(MatDialog);
  permissions = inject(PermissionsService);

  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  displayedColumns: string[] = ['model', 'buyed_at', 'chip', 'memory', 'active_user', 'actions'];
  dataSource: MatTableDataSource<Computer> = new MatTableDataSource<Computer>();
  activeWorkers: User[] = [];
  filterForm: UntypedFormGroup;

  constructor() {
    super(inject(Router), inject(UntypedFormBuilder), inject(ActivatedRoute), inject(UtilsService));
  }

  override ngOnInit(): void {
    this.fetchWorkers();
    super.ngOnInit();
  }

  onOwnerChange(idx: number, user_id: number | undefined) {
    if (user_id != null) {
      this.assignNewOwner(idx, user_id);
    } else {
      this.dettachOwner(idx);
    }
  }

  navigateToHolded(computer: Computer) {
    window.open(`https://app.holded.com/accounting/assets/${computer.holded_asset_id}`, '_blank');
  }

  openDialog(computer: Computer | undefined = undefined) {
    const dialogRef = this.dialog.open(CreditComputerDialogComponent, {
      data: { computer: computer },
      width: '700px',
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data != undefined) {
        this.fetchData();
      }
    });
  }

  private dettachOwner(idx: number) {
    if (
      this.dataSource.data[idx].active_user != undefined &&
      confirm('¿Estás seguro que quieres desasignar este usuario de este ordenador?')
    ) {
      this.dataSource.data[idx].active_user = undefined;
      this.api.dettachUserFromComputer(this.dataSource.data[idx].id).subscribe(data => {});
    }
  }

  private assignNewOwner(idx: number, user_id: number) {
    if (
      (this.dataSource.data[idx].active_user == undefined || this.dataSource.data[idx].active_user?.id != user_id) &&
      confirm('¿Estás seguro que quieres cambiar el que usará este portátil a partir de ahora?')
    ) {
      const user: User = this.activeWorkers.find((u: User) => u.id == user_id) as User;
      this.dataSource.data[idx].active_user = user;

      this.api.attachUserToComputer(this.dataSource.data[idx].id, user.id).subscribe(data => {});
    }
  }

  override fetchData() {
    const body: any = { ...this.filterForm.value, ...{ append: 'active_user', order_by: 'buyed_at:desc' } };
    this.api.getComputers(body).subscribe(data => {
      this.dataSource.data = data.data;
      this.setMetadata(+data.meta.total, data.meta.current_page - 1, data.meta.per_page);
    });
  }

  private fetchWorkers() {
    this.api.getActiveEmployees().subscribe(data => {
      this.activeWorkers = data;
    });
  }
}
